<<h2 mat-dialog-title>Bulk Error Update Scope</h2>

<mat-dialog-content>
    <div class="container d-flex flex-column flex-wrap mb-2 gap-2">
        <div class="row gap-2 d-flex">
             <p>Updating {{ selectedErrorIds().length }} Errors:</p>
            @if (bulkUpdateSelectedStatus(); as status) {
                <p>New Status: {{ status.statusName }}</p>
            }
        </div>

        <!-- Toggle Groups Row -->
        <div class="row gap-2 d-flex mb-3">

            <div class="col-sm">
                <h6>Critical Error</h6>
                <mat-button-toggle-group 
                    name="criticalError" 
                    class="d-flex flex-wrap"
                    [value]="criticalError()"
                    (change)="setCriticalError($event.value)"
                    aria-label="Critical Error">
                    <mat-button-toggle value="true">Yes</mat-button-toggle>
                    <mat-button-toggle value="false">No</mat-button-toggle>
                    <mat-button-toggle>No Update</mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <div class="col-sm">
                <h6>Action Needed</h6>
                <mat-button-toggle-group 
                    name="actionNeeded" 
                    class="d-flex flex-wrap"
                    [value]="actionNeeded()"
                    (change)="setActionNeeded($event.value)"
                    aria-label="Action Needed">
                    <mat-button-toggle value="true">Yes</mat-button-toggle>
                    <mat-button-toggle value="false">No</mat-button-toggle>
                    <mat-button-toggle>No Update</mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <div class="col-sm">
                <h6>Automated Resolution</h6>
                <mat-button-toggle-group 
                    name="autoResolution" 
                    class="d-flex flex-wrap"
                    [value]="automatedResolution()"
                    (change)="setAutomatedResolution($event.value)"
                    aria-label="Auto Resolution">
                    <mat-button-toggle value="true">Yes</mat-button-toggle>
                    <mat-button-toggle value="false">No</mat-button-toggle>
                    <mat-button-toggle>No Update</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>

        <!-- Status and JIRA Row -->
        <div class="row gap-2 d-flex">
            <div class="col-4 me-2">
                <mat-form-field appearance="fill">
                    <mat-label>Update to Status</mat-label>
                    <mat-select 
                        [value]="bulkUpdateSelectedStatus()"
                        (selectionChange)="updateBulkStatus($event)">
                        @for(status of statuses(); track status.currentStatusId) {
                            <mat-option [value]="status">
                                {{status.statusName}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg">
                <mat-form-field class="w-100 form-field-webkit-full-width" appearance="fill">
                    <mat-label>Jira Ticket URL</mat-label>
                    <input matInput 
                        maxlength="200" 
                        [value]="jiraStoryURL()"
                        (input)="setJiraStoryURL($event)"
                        placeholder="Enter JIRA URL" 
                        title="JIRA Ticket URL">
                </mat-form-field>
            </div>
        </div>
        
        @if (isStatusResolved()) {
            <div class="row gap-2 d-flex">
                <span>
                    <h6>Resolution Comment:</h6>
                </span>
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Max 200 characters</mat-label>
                    <input matInput 
                        maxlength="200" 
                        [value]="resolutionComment()"
                       (input)="setResolutionComment($event)"
                        placeholder="Enter resolution comment" 
                        title="Resolution Comment"
                        required>
                </mat-form-field>
            </div>
        }
        
    </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button matButton
            [disabled]="!canUpdate() || isUpdating()"
            (click)="performBulkUpdate()">
            @if (isUpdating()) {
                Updating...
            } @else {
                Update Status
            }
        </button>
        <button matButton (click)="closeDialog()">Close</button>
</mat-dialog-actions>